export default "__VITE_ASSET__aoHBcGos__"